export const CRYPTOCOM_REFEREE_SUBMITTED_KEY = "cryptocom_referee_submitted";
export const CRYPTOCOM_SUBMIT_COOLDOWN_SECONDS = 30;
